import axiosInstance from 'axios-config';

export const getAnaliserResult = async (authHeader, id) => {
  try {
    const response = await axiosInstance.get('/url/analyser_results/' + id,
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const getS3Data = async (url) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  };
};